export function formatTime(date: string): string {
  return new Date(date).toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' });
}

export function formatDay(date: string) {
  return new Date(date).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function formatDayWithTime(date: string) {
  return formatDay(date) + ' om ' + formatTime(date);
}

export function dateSort(a: Date, b: Date): number {
  return a.getTime() - b.getTime();
}

export function formatIso8601(date: string | Date): string {
  if (typeof date === 'string') date = new Date(date);
  const iso: string = date.toISOString();
  const strippedIso: string = iso.replace('.000Z', '');
  const offset: string = '+00:00';

  return `${strippedIso}${offset}`;
}
